import PropTypes from 'prop-types';
import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import VerificationInput from 'react-verification-input';
import Button from './components/Button';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { connect } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Link, useNavigate } from 'react-router-dom';
import { validateDeviceCode } from 'store/modules/login/actions';
import { ArrowLeft } from 'assets/images';

const ActivationCode = ({ verifyCode }) => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [open, setOpen] = React.useState(null);
  const [value, setValue] = React.useState('');
  const classes = useStyles();
  const navigate = useNavigate();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(null);
  };
  const verifyDeviceCode = () => {
    setLoading(true);
    verifyCode(value, (status, response) => {
      setLoading(false);
      if (status && response) {
        setOpen('Login successful');
        setTimeout(() => navigate('/settings'), 2000);
      } else {
        setError(response?.message || 'error');
      }
    });
  };

  return (
    <Box className="outerContainer">
      <Snackbar
        autoHideDuration={6000}
        onClose={handleClose}
        open={open !== null}>
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          {open}
        </Alert>
      </Snackbar>
      <Link className={classes.link} to={-1}>
        <ArrowLeft
          color="#000"
          height={20}
          style={{ marginRight: '9px' }}
          width={20}
        />
        <Box className={classes.subHeader}>back</Box>
      </Link>
      <Box className="center" sx={{ padding: '24px 16px', height: '100%' }}>
        <Box className={classes.subHeader} style={{ padding: '20px' }}>
          Please enter the 16-digit activation code provided by your Video
          Window administrator
        </Box>
        <div className="custom-styles">
          <VerificationInput
            autoFocus={true}
            classNames={{
              container: 'vinput-container-code',
              character: 'vinput-character',
              characterInactive: 'vinput-character-inactive',
              characterSelected: 'vinput-character--selected'
            }}
            length={16}
            onChange={setValue}
            placeholder=""
            value={value}
          />
        </div>
        {error ? (
          <Box sx={{ marginTop: '20px' }} className="center">
            <Button disabled={true} gray={true}>
              Submit
            </Button>
            <Box
              className="errorText"
              sx={{ marginTop: '20px', maxWidth: '60%' }}>
              Sorry, the activation code you entered isn’t valid, please contact
              your Video Window administrator for a new activation code
            </Box>
            <Box className={classes.hint} style={{ marginTop: '16px' }}>
              or
            </Box>
            <div className="link" loading={loading} onClick={verifyDeviceCode}>
              <Button blue={true}>Try again</Button>
            </div>
          </Box>
        ) : (
          <Box sx={{ marginTop: '20px' }}>
            <Button blue={true} loading={loading} onClick={verifyDeviceCode}>
              Submit
            </Button>
            <Box className={classes.hint}>
              Don’t have an activation code? Please contact your Video Window
              administrator for assistance
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

ActivationCode.propTypes = {
  verifyCode: PropTypes.func
};
const mapStateToProps = () => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    verifyCode: (code, callback) => dispatch(validateDeviceCode(code, callback))
  };
};

const useStyles = makeStyles((theme) => ({
  link: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '50px',
    marginBottom: '16px',
    textDecoration: 'none'
  },
  emailView: {
    display: 'flex',
    justifyContent: 'space-between',
    '@media (max-width: 600px)': {
      display: 'block'
    }
  },
  header: {
    ...theme.typography.labelRegular,
    color: theme.palette.text07Info
  },
  subHeader: {
    ...theme.typography.labelSmall,
    color: theme.palette.text07Info
  },
  hint: {
    ...theme.typography.labelTiny,
    color: theme.palette.text05
  },
  error: {
    ...theme.typography.labelTiny,
    color: theme.palette.actionDanger,
    padding: '20px'
  },
  footer: {
    ...theme.typography.labelTiny,
    color: theme.palette.text07Info,
    flex: 1,
    textAlign: 'center',
    '@media (minWidth: 600px)': {
      width: '30%'
    }
  },
  footerLink: {
    ...theme.typography.labelTiny,
    color: theme.palette.screen01
  }
}));

export default React.memo(
  connect(mapStateToProps, mapDispatchToProps)(withBoundary(ActivationCode))
);
